var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "formInput__wrapper" }, [
    _c(
      "button",
      {
        class: _vm.fieldClasses,
        attrs: {
          id: _vm.fieldId,
          type: _vm.fieldType,
          name: _vm.fieldName,
          disabled: _vm.fieldDisabled,
          "data-gtm": _vm.dataGtm,
        },
        on: { click: _vm.handleClick },
      },
      [
        _vm.fieldValue
          ? [_vm._v("\n            " + _vm._s(_vm.fieldValue) + "\n        ")]
          : _vm.fieldLabel
          ? [_vm._v("\n            " + _vm._s(_vm.fieldLabel) + "\n        ")]
          : _vm._e(),
        _vm._v(" "),
        _vm._t("default"),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }